import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

import hotel_store from './components/hotel_store'

Vue.use(Vuex)

const state = {
  latitude: '', // 当前位置纬度
  longitude: '', // 当前位置经度

  fmShopDetials: null, // 澳门商店详情
  fmShopHeader: null,
  fmShopID: '',

  queryDistancesTitle: '', // 商店距离选项栏title
  queryShopSubCategoriesTitle: '', // 商店类型选项栏title
  queryRegionsTitle: '', // 商店地区选项栏title
  shopPlaceholder: '', // 商店搜索框提示信息
  shopCategoryId: '', // 商店类型id
  shopSubCategoriesId: '', // 子类型

  errorTips: '',
  headGoBackItem: '',
  mcShops: [],
  Xtoken: '',
  beforeLoginUrl: '',
  alertShow: false,
  alertMessage: '',
  currentPage: '',
  landingPage: '',
  savePt: { x: 0, y: 0 },
  userInfo: { nickname: '', usercode: '', avatar_url: '' }, // 用户信息
  orderList: [{ orderno: '111122222' }], // 订单列表
  orderDetail: null, // 订单产品详情
  login: false, // 是否登录
  locationinfo: 'shane',
  destination_scenic_spot_info: { spot_id: -1, name: '' },
  hotelInfo: {
    keywords: '',
    level: 0,
    min_price: 0,
    max_price: -1,
    check_in_date: '',
    check_out_date: '',
    sort_type: 0,
    destination_scenic_spot_id: 0,
    destination_scenic_spot_name: '',
    levelPriceInfo: '',
    city_id:'',
    city_name:'',
  },
  commodidy_dates: [],
  order_option:[],
  is_calendar_show: 1,
  booking_commodity_id: '',
  tabbar_index:0,
  isBocAPP: "" // 添加 isBocAPP 状态
}

export default new Vuex.Store({
  modules: {
    hotel: hotel_store
  },
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js